<div class="grid guts-p-t-3 grid--isMobile-max-width">
  <div *ngIf="showSidebar" class="grid__col-md-3 grid__col-xs-12">
    <dgx-skip-nav
      containerName="learner-home-container"
      [linkText]="skipLinkText"
    ></dgx-skip-nav>
    <aside>
      <div class="box grid__col-12">
        <dgx-user-summary></dgx-user-summary>
        <dgx-learner-home-budget
          *ngIf="showLearningBudget"
        ></dgx-learner-home-budget>
        <dgx-learner-home-focus-skills></dgx-learner-home-focus-skills>
        <dgx-learner-home-resources tabindex="0"></dgx-learner-home-resources>
        <dgx-monthly-activity></dgx-monthly-activity>
      </div>
      <dgx-quick-links></dgx-quick-links>
    </aside>
  </div>
  <div
    class="grid__col-md-9 grid__col--bleed guts-p-b-2"
    [ngClass]="{
      'grid__col-lg-12': rowLength == 4,
      'grid__col-lg-9': rowLength != 4
    }"
    id="learner-home-container"
  >
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</div>
